import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-tp-logs',
  templateUrl: './admin-tp-logs.component.html',
  styleUrls: ['./admin-tp-logs.component.scss']
})
export class AdminTpLogsComponent implements OnInit {
  selected_tab: any = 1;

  constructor() { }

  ngOnInit(): void {
    const tableHeader = document.getElementsByTagName("th");
    for (let i = 0; i < tableHeader.length; i++) {
      tableHeader[i].classList.add("headerSortDown");
    }
  }
  selectTab(tab){
    this.selected_tab = tab
  }


}
